import { mapActions, mapGetters, mapMutations } from 'vuex'
import general from '../general/index.vue'
import countries from '../countries/index.vue'
import seo from '../seo/index.vue'
import translations from '../translations/index.vue'

export default {
  name: 'setting-course-categories-dialog-view',
  data () {
    return {
      dialog: true,
      activeTab: 'general',
    }
  },
  components: {
    translations,
    countries,
    general,
    seo
  },
  watch: {
    openDialogView () {
      this.dialog = this.openDialogView
    }
  },
  computed: {
    ...mapGetters({
      currentItem: 'settingCourseCategories/currentItem',
      openDialogView: 'settingCourseCategories/openDialogView',
      basicLocales: 'setting/basicLocales',
      basicCountries: 'setting/basicCountries',
      editId: 'settingCourseCategories/editId',
	  isLoading: 'settingCourseCategories/isLoading',
	  updateSeoLoading: 'settingCourseCategories/updateSeoLoading',
    }),
    tabs () {
      return [
        {
          name: 'General',
          slug: 'general',
          id: 1
        },
        {
          name: 'Countries',
          slug: 'countries',
          id: 2,
          disabled: !this.currentItem
        },
        {
          name: 'Translations',
          slug: 'translations',
          id: 3,
          disabled: !this.currentItem
        },
        {
          name: 'SEO',
          slug: 'seo',
          id: 4,
          disabled: !this.currentItem
        }
      ]
    }
  },
  created () {
    if (!this.basicLocales.length) {
      this.fetchBasicLocales()
    }
    if (!this.basicCountries.length) {
      this.fetchBasicCountries()
    }
    if (this.editId) {
      this.fetchItem()
    }
  },
  methods: {
    ...mapActions({
      fetchItem: 'settingCourseCategories/GET_LIST_ITEM',
      fetchBasicLocales: 'setting/GET_BASIC_LOCALES',
      fetchBasicCountries: 'setting/GET_BASIC_COUNTRIES',
    }),
    ...mapMutations({
      changeDialogView: 'settingCourseCategories/CHANGE_DIALOG_VIEW',
      changeEditId: 'settingCourseCategories/CHANGE_EDIT_ID',
      setContent: 'settingCourseCategories/SET_ITEM',
      setBasicCountries: 'setting/SET_BASIC_COUNTRIES',
    }),
    changeCloseDialog () {
      this.dialog = false
      this.changeDialogView(false)
      this.changeEditId('')
    },

	save(){
	  this.$refs['general'].$emit('event-save');
	}
  },
  destroyed () {
    this.setContent(null)
    this.setBasicCountries([])
  }
}
